// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-6004f404] .el-table {\n  width: 970px;\n}\n.btn[data-v-6004f404] {\n  position: relative;\n  top: -15px;\n  left: 12px;\n}\n.title[data-v-6004f404] .el-alert {\n  padding: 0 16px !important;\n}", ""]);
// Exports
module.exports = exports;
